"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadFormOptionsResponseSchema = exports.leadConversionResponseSchema = exports.leadListResponseSchema = exports.leadListQuerySchema = exports.leadIntakeResponseSchema = exports.leadWarningSchema = exports.leadDetailSchema = exports.leadSchema = exports.leadActivitySchema = exports.leadAssigneeSchema = exports.convertLeadRequestSchema = exports.leadConversionCustomerSchema = exports.assignLeadRequestSchema = exports.updateLeadStatusRequestSchema = exports.updateLeadRequestSchema = exports.createLeadRequestSchema = exports.leadEstimatedValueSchema = exports.leadPreferredWindowSchema = exports.publicLeadSubmissionResponseSchema = exports.publicLeadSubmissionRequestSchema = exports.leadServiceAddressSchema = exports.publicLeadIntakeBusinessSchema = exports.publicLeadIntakeSettingsResponseSchema = exports.updatePublicLeadIntakeSettingsRequestSchema = exports.publicLeadIntakeSettingsSchema = exports.publicLeadAttributionSchema = exports.publicLeadIntakeSlugSchema = exports.publicLeadChannelSchema = exports.leadSourceSchema = exports.leadStatusSchema = exports.leadIdSchema = void 0;
const zod_1 = require("zod");
const pagination_1 = require("./pagination");
const marketing_attribution_1 = require("./marketing-attribution");
const optionalText = (maximum) => zod_1.z
    .string()
    .trim()
    .max(maximum)
    .optional()
    .transform((value) => value || undefined);
const nullableText = (maximum) => zod_1.z
    .union([zod_1.z.string().trim().max(maximum), zod_1.z.null()])
    .optional()
    .transform((value) => (value === undefined ? undefined : value || null));
exports.leadIdSchema = zod_1.z.string().uuid();
exports.leadStatusSchema = zod_1.z.enum([
    "NEW",
    "OPEN",
    "CONTACTED",
    "QUALIFIED",
    "WON",
    "LOST",
    "ARCHIVED",
]);
exports.leadSourceSchema = zod_1.z.enum([
    "MANUAL",
    "PHONE",
    "SMS",
    "WEBSITE",
    "ONLINE_BOOKING",
    "REFERRAL",
    "MARKETPLACE",
    "API",
    "APP",
    "OTHER",
]);
exports.publicLeadChannelSchema = zod_1.z.enum([
    "DIRECT",
    "WEBSITE",
    "GOOGLE_BUSINESS_PROFILE",
    "GOOGLE_LOCAL_SERVICES",
]);
exports.publicLeadIntakeSlugSchema = zod_1.z
    .string()
    .trim()
    .min(3)
    .max(48)
    .regex(/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/)
    .refine((value) => !value.includes("--"), {
    message: "Use single hyphens between words.",
});
exports.publicLeadAttributionSchema = zod_1.z.object({
    channel: exports.publicLeadChannelSchema.default("DIRECT"),
    landingPath: zod_1.z.string().trim().max(500).nullable().default(null),
    referrer: zod_1.z.string().trim().url().max(2_048).nullable().default(null),
    utmSource: zod_1.z.string().trim().max(120).nullable().default(null),
    utmMedium: zod_1.z.string().trim().max(120).nullable().default(null),
    utmCampaign: zod_1.z.string().trim().max(160).nullable().default(null),
    utmTerm: zod_1.z.string().trim().max(160).nullable().default(null),
    utmContent: zod_1.z.string().trim().max(160).nullable().default(null),
    gclid: zod_1.z.string().trim().max(200).nullable().optional(),
    gbraid: zod_1.z.string().trim().max(200).nullable().optional(),
    wbraid: zod_1.z.string().trim().max(200).nullable().optional(),
    firstTouch: marketing_attribution_1.marketingAttributionTouchSchema.nullable().optional(),
    lastTouch: marketing_attribution_1.marketingAttributionTouchSchema.nullable().optional(),
    adUserDataConsent: marketing_attribution_1.marketingAttributionConsentSchema.optional(),
});
exports.publicLeadIntakeSettingsSchema = zod_1.z.object({
    enabled: zod_1.z.boolean(),
    slug: exports.publicLeadIntakeSlugSchema,
    displayName: zod_1.z.string().trim().min(1).max(120),
    primaryAccentColor: zod_1.z
        .string()
        .regex(/^#[0-9a-f]{6}$/i)
        .transform((value) => value.toUpperCase()),
    headline: zod_1.z.string().trim().min(2).max(160),
    introduction: zod_1.z.string().trim().min(2).max(500),
    confirmationMessage: zod_1.z.string().trim().min(2).max(500),
    collectServiceAddress: zod_1.z.boolean(),
    requireConsent: zod_1.z.boolean(),
    consentText: zod_1.z.string().trim().min(2).max(500),
    privacyPolicyUrl: zod_1.z.string().trim().url().max(2_048).nullable(),
    intakeUrl: zod_1.z.string().url(),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.updatePublicLeadIntakeSettingsRequestSchema = exports.publicLeadIntakeSettingsSchema
    .omit({ intakeUrl: true, updatedAt: true })
    .superRefine((value, context) => {
    if (value.requireConsent && !value.privacyPolicyUrl) {
        context.addIssue({
            code: "custom",
            path: ["privacyPolicyUrl"],
            message: "A privacy policy URL is required when consent is required.",
        });
    }
});
exports.publicLeadIntakeSettingsResponseSchema = zod_1.z.object({
    settings: exports.publicLeadIntakeSettingsSchema,
    canManage: zod_1.z.boolean(),
});
exports.publicLeadIntakeBusinessSchema = zod_1.z.object({
    canonicalSlug: exports.publicLeadIntakeSlugSchema,
    displayName: zod_1.z.string().min(1).max(120),
    logoUrl: zod_1.z.string().url().nullable(),
    primaryAccentColor: zod_1.z.string().regex(/^#[0-9A-F]{6}$/),
    headline: zod_1.z.string().min(2).max(160),
    introduction: zod_1.z.string().min(2).max(500),
    confirmationMessage: zod_1.z.string().min(2).max(500),
    collectServiceAddress: zod_1.z.boolean(),
    requireConsent: zod_1.z.boolean(),
    consentText: zod_1.z.string().min(2).max(500),
    privacyPolicyUrl: zod_1.z.string().url().nullable(),
});
exports.leadServiceAddressSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(120),
    addressLine1: zod_1.z.string().trim().min(1).max(160),
    addressLine2: zod_1.z.string().trim().max(160).nullable().default(null),
    city: zod_1.z.string().trim().min(1).max(100),
    state: zod_1.z
        .string()
        .trim()
        .length(2)
        .transform((value) => value.toUpperCase()),
    postalCode: zod_1.z.string().trim().min(5).max(10),
    country: zod_1.z.literal("US").default("US"),
    timezone: zod_1.z.string().trim().min(1).max(64),
});
exports.publicLeadSubmissionRequestSchema = zod_1.z
    .object({
    idempotencyKey: zod_1.z.string().uuid(),
    firstName: zod_1.z.string().trim().min(1).max(80),
    lastName: zod_1.z.string().trim().min(1).max(80),
    companyName: optionalText(160),
    phone: optionalText(32),
    email: zod_1.z
        .string()
        .trim()
        .toLowerCase()
        .pipe(zod_1.z.string().email().max(320))
        .optional(),
    summary: zod_1.z.string().trim().min(2).max(160),
    description: optionalText(5_000),
    serviceAddress: exports.leadServiceAddressSchema.optional(),
    consentAccepted: zod_1.z.boolean().default(false),
    attribution: exports.publicLeadAttributionSchema.default({
        channel: "DIRECT",
        landingPath: null,
        referrer: null,
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmTerm: null,
        utmContent: null,
        gclid: null,
        gbraid: null,
        wbraid: null,
        firstTouch: null,
        lastTouch: null,
        adUserDataConsent: "UNSPECIFIED",
    }),
    website: zod_1.z.string().max(200).optional().default(""),
})
    .superRefine((value, context) => {
    if (!value.phone && !value.email) {
        context.addIssue({
            code: "custom",
            path: ["phone"],
            message: "A phone number or email address is required.",
        });
    }
});
exports.publicLeadSubmissionResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    message: zod_1.z.string().min(1).max(500),
});
exports.leadPreferredWindowSchema = zod_1.z
    .object({
    startAt: zod_1.z.string().datetime({ offset: true }),
    endAt: zod_1.z.string().datetime({ offset: true }),
})
    .refine((value) => Date.parse(value.endAt) > Date.parse(value.startAt), {
    path: ["endAt"],
    message: "Preferred window end must be after its start.",
});
exports.leadEstimatedValueSchema = zod_1.z.object({
    amountCents: zod_1.z.number().int().min(0).max(100_000_000),
    currency: zod_1.z.literal("USD").default("USD"),
});
const leadContactInputShape = {
    firstName: zod_1.z.string().trim().min(1).max(80),
    lastName: zod_1.z.string().trim().min(1).max(80),
    companyName: optionalText(160),
    phone: optionalText(32),
    email: zod_1.z
        .string()
        .trim()
        .toLowerCase()
        .pipe(zod_1.z.string().email().max(320))
        .optional(),
};
exports.createLeadRequestSchema = zod_1.z
    .object({
    source: exports.leadSourceSchema.default("MANUAL"),
    sourceReference: optionalText(255),
    ...leadContactInputShape,
    serviceAddress: exports.leadServiceAddressSchema.optional(),
    serviceCategoryId: zod_1.z.string().uuid().optional(),
    summary: zod_1.z.string().trim().min(2).max(160),
    description: optionalText(5_000),
    preferredWindow: exports.leadPreferredWindowSchema.optional(),
    estimatedValue: exports.leadEstimatedValueSchema.optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
})
    .superRefine((value, context) => {
    if (value.source !== "MANUAL" && !value.sourceReference) {
        context.addIssue({
            code: "custom",
            path: ["sourceReference"],
            message: "External lead sources require a source reference.",
        });
    }
    if (!value.phone && !value.email) {
        context.addIssue({
            code: "custom",
            path: ["phone"],
            message: "A phone number or email address is required.",
        });
    }
});
exports.updateLeadRequestSchema = zod_1.z
    .object({
    firstName: zod_1.z.string().trim().min(1).max(80).optional(),
    lastName: zod_1.z.string().trim().min(1).max(80).optional(),
    companyName: nullableText(160),
    phone: nullableText(32),
    email: zod_1.z
        .union([
        zod_1.z.string().trim().toLowerCase().pipe(zod_1.z.string().email().max(320)),
        zod_1.z.null(),
    ])
        .optional(),
    serviceAddress: zod_1.z.union([exports.leadServiceAddressSchema, zod_1.z.null()]).optional(),
    serviceCategoryId: zod_1.z.union([zod_1.z.string().uuid(), zod_1.z.null()]).optional(),
    summary: zod_1.z.string().trim().min(2).max(160).optional(),
    description: nullableText(5_000),
    preferredWindow: zod_1.z.union([exports.leadPreferredWindowSchema, zod_1.z.null()]).optional(),
    estimatedValue: zod_1.z.union([exports.leadEstimatedValueSchema, zod_1.z.null()]).optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .refine((value) => Object.values(value).some((item) => item !== undefined), {
    message: "At least one lead field is required.",
});
exports.updateLeadStatusRequestSchema = zod_1.z.object({
    status: zod_1.z.enum(["NEW", "OPEN", "CONTACTED", "QUALIFIED", "LOST"]),
});
exports.assignLeadRequestSchema = zod_1.z.object({
    assignedToUserId: zod_1.z.string().uuid().nullable(),
});
const existingLeadCustomerSchema = zod_1.z.object({
    mode: zod_1.z.literal("EXISTING"),
    customerId: zod_1.z.string().uuid(),
    serviceLocationId: zod_1.z.string().uuid(),
});
const newLeadCustomerSchema = zod_1.z.object({
    mode: zod_1.z.literal("NEW"),
    customer: zod_1.z.object({
        type: zod_1.z.enum(["RESIDENTIAL", "COMMERCIAL"]).default("RESIDENTIAL"),
        displayName: zod_1.z.string().trim().min(2).max(160),
        email: zod_1.z
            .string()
            .trim()
            .toLowerCase()
            .pipe(zod_1.z.string().email().max(320))
            .nullable()
            .default(null),
        phone: zod_1.z.string().trim().max(32).nullable().default(null),
    }),
    serviceLocation: exports.leadServiceAddressSchema,
});
exports.leadConversionCustomerSchema = zod_1.z.discriminatedUnion("mode", [
    existingLeadCustomerSchema,
    newLeadCustomerSchema,
]);
const estimateConversionSchema = zod_1.z.object({
    target: zod_1.z.literal("ESTIMATE"),
    idempotencyKey: zod_1.z.string().uuid(),
    customer: exports.leadConversionCustomerSchema,
    estimate: zod_1.z.object({
        recipientContactId: zod_1.z.string().uuid().optional(),
        notes: optionalText(5_000),
        expiresAt: zod_1.z.string().datetime({ offset: true }).optional(),
        taxRateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
        lines: zod_1.z
            .array(zod_1.z.object({
            catalogItemId: zod_1.z.string().uuid(),
            quantityMilli: zod_1.z.number().int().min(1).max(1_000_000),
        }))
            .min(1)
            .max(100)
            .refine((lines) => new Set(lines.map((line) => line.catalogItemId)).size ===
            lines.length, { message: "Each pricebook item can appear only once." }),
    }),
});
const jobConversionSchema = zod_1.z.object({
    target: zod_1.z.literal("JOB"),
    idempotencyKey: zod_1.z.string().uuid(),
    customer: exports.leadConversionCustomerSchema,
    job: zod_1.z.object({
        businessLocationId: zod_1.z.string().uuid().optional(),
        summary: zod_1.z.string().trim().min(2).max(160).optional(),
        description: optionalText(5_000),
        priority: zod_1.z.enum(["LOW", "NORMAL", "HIGH", "URGENT"]).default("NORMAL"),
    }),
});
exports.convertLeadRequestSchema = zod_1.z.discriminatedUnion("target", [
    estimateConversionSchema,
    jobConversionSchema,
]);
exports.leadAssigneeSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
    membershipId: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().nullable(),
    email: zod_1.z.string().email().nullable(),
});
exports.leadActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.enum([
        "CREATED",
        "UPDATED",
        "ASSIGNED",
        "STATUS_CHANGED",
        "CONVERTED",
        "ARCHIVED",
    ]),
    actor: zod_1.z.object({
        type: zod_1.z.enum(["STAFF", "APP", "SYSTEM"]),
        membershipId: zod_1.z.string().uuid().nullable(),
        installationId: zod_1.z.string().uuid().nullable(),
        name: zod_1.z.string().nullable(),
    }),
    title: zod_1.z.string().min(1).max(240),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.leadSchema = zod_1.z.object({
    id: exports.leadIdSchema,
    businessId: zod_1.z.string().uuid(),
    source: exports.leadSourceSchema,
    sourceReference: zod_1.z.string().nullable(),
    status: exports.leadStatusSchema,
    customerId: zod_1.z.string().uuid().nullable(),
    assignedToUserId: zod_1.z.string().uuid().nullable(),
    assignee: exports.leadAssigneeSchema.nullable(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    companyName: zod_1.z.string().nullable(),
    phone: zod_1.z.string().nullable(),
    email: zod_1.z.string().email().nullable(),
    serviceAddress: exports.leadServiceAddressSchema.nullable(),
    serviceCategoryId: zod_1.z.string().uuid().nullable(),
    summary: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    preferredWindow: exports.leadPreferredWindowSchema.nullable(),
    estimatedValue: exports.leadEstimatedValueSchema.nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    convertedServiceLocationId: zod_1.z.string().uuid().nullable(),
    convertedEstimateId: zod_1.z.string().uuid().nullable(),
    convertedJobId: zod_1.z.string().uuid().nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    convertedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    archivedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.leadDetailSchema = exports.leadSchema.extend({
    activities: zod_1.z.array(exports.leadActivitySchema),
});
exports.leadWarningSchema = zod_1.z.object({
    code: zod_1.z.enum(["POSSIBLE_DUPLICATE_CONTACT"]),
    message: zod_1.z.string().min(1).max(240),
    matchingCustomerIds: zod_1.z.array(zod_1.z.string().uuid()),
    matchingLeadIds: zod_1.z.array(zod_1.z.string().uuid()),
});
exports.leadIntakeResponseSchema = zod_1.z.object({
    lead: exports.leadDetailSchema,
    warnings: zod_1.z.array(exports.leadWarningSchema),
    idempotentReplay: zod_1.z.boolean(),
});
const queryBooleanSchema = zod_1.z.preprocess((value) => {
    if (value === "true")
        return true;
    if (value === "false")
        return false;
    return value;
}, zod_1.z.boolean().optional());
exports.leadListQuerySchema = pagination_1.paginationQuerySchema.extend({
    search: zod_1.z.string().trim().max(160).optional(),
    status: exports.leadStatusSchema.optional(),
    source: exports.leadSourceSchema.optional(),
    assignedToUserId: zod_1.z.string().uuid().optional(),
    unassigned: queryBooleanSchema,
    createdFrom: zod_1.z.string().datetime({ offset: true }).optional(),
    createdTo: zod_1.z.string().datetime({ offset: true }).optional(),
});
exports.leadListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.leadSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema,
});
exports.leadConversionResponseSchema = zod_1.z.object({
    lead: exports.leadDetailSchema,
    target: zod_1.z.enum(["ESTIMATE", "JOB"]),
    customerId: zod_1.z.string().uuid(),
    serviceLocationId: zod_1.z.string().uuid(),
    estimateId: zod_1.z.string().uuid().nullable(),
    jobId: zod_1.z.string().uuid().nullable(),
    idempotentReplay: zod_1.z.boolean(),
});
exports.leadFormOptionsResponseSchema = zod_1.z.object({
    customers: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string(),
        locations: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string().uuid(),
            name: zod_1.z.string(),
            addressLine1: zod_1.z.string(),
            city: zod_1.z.string(),
            state: zod_1.z.string(),
            postalCode: zod_1.z.string(),
        })),
    })),
    catalogItems: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        name: zod_1.z.string(),
        unitPriceCents: zod_1.z.number().int().nonnegative(),
    })),
    teamMembers: zod_1.z.array(exports.leadAssigneeSchema),
});
//# sourceMappingURL=lead.js.map